import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "file-left ellipsis"
};
const _hoisted_2 = {
  class: "file-center"
};
const _hoisted_3 = {
  class: "file-size file-size-origin ellipsis"
};
const _hoisted_4 = {
  class: "file-size ellipsis"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "file-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_process = _resolveComponent("process");
  const _component_el_link = _resolveComponent("el-link");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file", {
      'is-mobile': $props.isMobile
    }])
  }, [_createElementVNode("div", _hoisted_1, _toDisplayString($props.file.name), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($options.formatFileSize($props.file.size)), 1), _createVNode(_component_process, {
    class: "file-process",
    process: $props.file.status
  }, null, 8, ["process"]), _createElementVNode("div", _hoisted_4, [$props.file?.response?.data?.size ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($options.formatFileSize($props.file.response.data.size)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [$options.isSuccess ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$options.showCopyLink ? (_openBlock(), _createBlock(_component_el_link, {
    key: 0,
    type: "primary",
    class: "file-right-item",
    underline: false,
    onClick: $options.copyLink
  }, {
    default: _withCtx(() => [_createTextVNode("复制链接")]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_link, {
    type: "primary",
    class: "file-right-item",
    underline: false,
    onClick: $options.download
  }, {
    default: _withCtx(() => [_createTextVNode("下载")]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", {
    class: _normalizeClass(["file-right-item save", [$options.saved > 0 ? 'saved--warn' : '']])
  }, _toDisplayString($options.saved) + "%", 3)], 64)) : _createCommentVNode("", true)])], 2);
}